import { FSMPlan } from 'containers/settings/constants';
import { FSM_FREE_PLAN_ROUTES, FSM_UPGRADE_NEEDED_ROUTES } from './constants';
import { store } from 'store/store';

export const shouldShowFSMModal = (pathname: string) => {
  const { rootReducer } = store.getState();
  const { showFSMModal } = rootReducer.modal;
  const { subscriptionActivity } = rootReducer.app.merchantCustomizations;
  const { currentFSMPlan, isInFreeTrial } = subscriptionActivity ?? {};

  const isFSMSubscriptionNeeded = FSM_FREE_PLAN_ROUTES.some(route => pathname.includes(route));

  const isUpgradeNeeded = FSM_UPGRADE_NEEDED_ROUTES.some(route => pathname.includes(route));

  if (currentFSMPlan === FSMPlan.NO_PLAN) {
    return (isFSMSubscriptionNeeded || isUpgradeNeeded) && showFSMModal;
  }
  if (currentFSMPlan === FSMPlan.FREE) {
    return isUpgradeNeeded && showFSMModal;
  }
  if (!isInFreeTrial) {
    return isUpgradeNeeded && showFSMModal;
  }

  return false;
};
